export default __webpack_public_path__ + "static/grouped-column-f52f601a562204c15fc3054e5d086c24.png";